<template>
    <div>
        <el-col :span="24" class="toolbar uptool">
            <el-form :inline="true">
                <el-form-item>
                    <el-input v-model="SearchDid" placeholder="请输入设备ID" prefix-icon="el-icon-search" size="small"/>
                </el-form-item>

                <el-form-item>
                    <el-button type="small" size="small" @click="SelectionQuery">搜索</el-button>
                </el-form-item>

                <!--<el-dropdown trigger="click" type="primary" @command="handleSelectByEdition" style="margin-top:5px">-->
                <!--<el-button type="small" class="el-dropdown-link">-->
                <!--筛选[型号]-->
                <!--<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                <!--</el-button>-->
                <!--<el-dropdown-menu slot="dropdown">-->
                <!--<el-dropdown-item command="A08">轻度失能版</el-dropdown-item>-->
                <!--<el-dropdown-item command="A02">重度失能版</el-dropdown-item>-->
                <!--</el-dropdown-menu>-->
                <!--</el-dropdown>-->

                <el-form-item>
                    |
                </el-form-item>

                <el-form-item>
                    <el-dropdown trigger="click" type="primary" @command="handleSelectByOnlineStatus">
                        <el-button type="small" class="el-dropdown-link">
                            筛选 - [在线状态]
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="online">在线</el-dropdown-item>
                            <el-dropdown-item command="offline">下线</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-form-item>

                <el-tooltip effect="dark" content="点击取消筛选" placement="top" open-delay="1000"
                            v-if="SearchOnlineStatus != ''">
                    <el-form-item>
                        <el-button type="danger" size="mini" icon="el-icon-error" round @click="Refresh">
                            {{(SearchOnlineStatus == 'offline'?'下线':(SearchOnlineStatus
                            =='online'?'在线':'未知'))+total+'台'}}
                        </el-button>
                    </el-form-item>
                </el-tooltip>

                <el-form-item style="float: right;">
                    <el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <!--表格-->
        <el-table
          :data="List"
          v-loading="listloading"
          style="width: 100%">
            <el-table-column label="#" width="50" align="center">
                <template slot-scope="scope">
                    {{scope.$index+1}}
                </template>
            </el-table-column>
            <el-table-column prop="device_name" label="设备ID" align="center"/>
            <el-table-column prop="device_name" label="型号" align="center">
                <!--:filters="[{'text':'轻度失能版','value':'A08'},{'text':'重度失能版','value':'A02'},{'text':'其他','value':''}]"-->
                <!--:filter-method="filterEdition">-->
                <template slot-scope="scope">
                    {{getDeviceVersionName(scope.row.product_code,scope.row.edition_code)}}
                </template>
            </el-table-column>
            <el-table-column prop="first_time" label="首次上线时间" align="center"/>
            <el-table-column prop="last_time" label="末次上线时间" align="center"/>
            <el-table-column prop="online_count" label="上线总次数" align="center"/>
            <el-table-column prop="online_status" label="在线状态" align="center">
                <!--:filters="[{'text':'下线','value':'offline'},{'text':'在线','value':'online'}]"-->
                <!--:filter-method="filterOnlineStatus">-->
                <template slot-scope="scope">
                    <p v-if="scope.row.online_status == 'online'">
                        <i class="el-icon-upload" style="color:#11b95c"/>&nbsp在线
                    </p>
                    <p v-if="scope.row.online_status == 'offline'">
                        <i class="el-icon-warning" style="color:#ff4949"/>&nbsp下线
                    </p>
                    <p v-if="scope.row.online_status != 'online' && scope.row.online_status != 'offline'">
                        <i class="el-icon-question" style="color:#f7ba2a"/>&nbsp未知
                    </p>
                </template>
            </el-table-column>
            <el-table-column v-if="Limits.device_data_view" label="操作">
                <template slot-scope="scope">
                    <el-button v-if="List[scope.$index].edition != '机构版'"
                               @click="gotoDetails(scope.row,scope.$index,scope.column)"
                               size="small"
                               type="text">
                        查看
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="Pagesize"
          :current-page="Curpage"
          :total="total"
          @current-change="handlePageChanged">
        </el-pagination>

        <el-dialog title="运行状态" :visible.sync="detailsVisiable" :fullscreen="true"
                   :before-close="closeDeviceStatusDetailDialog">

            <el-row>
                <el-col :span="24">
                    <el-tag>{{curDid}}</el-tag>
                    <el-tag type="success">
                        <el-tooltip effect="dark" placement="top"
                                    v-if="dev_software_version_r != dev_software_version_f">
                            <div slot="content">r:v{{dev_software_version_r}} / f:v{{dev_software_version_f}}</div>
                            <i class="el-icon-warning" style="color:#ff4949"></i>
                        </el-tooltip>
                        &nbsp固件版本：v{{dev_software_version_r}}
                    </el-tag>
                    <el-tag type="warning">{{dev_edition}}</el-tag>
                    <el-tag type="danger">最近一次上线时间：{{last_online_time}}</el-tag>
                    <el-tag> 发货地址：{{`${shipping_prov}${shipping_city}${shipping_dist}${shipping_addr}`}}</el-tag>
                </el-col>
                <!--<el-col :span="12">-->
                <!--<span style="float: right;font-size: 6px;font-weight: bold;color: #808c939d;">每小时更新</span>-->
                <!--</el-col>-->
            </el-row>

            <el-tabs v-model="tabActiveName" @tab-click="clickTab">
                <el-tab-pane label="运行状态" name="1">
                    <el-row style="font-size: 10px;font-weight: bold;color: #808c939d;"> {{yxUpdateTime}}</el-row>
                    <el-row :gutter="0" v-for="(r,rindex) in yxTitles">
                        <el-col :span="6" v-for="(c, cindex) in r" :key="c" :offset="0">
                            <el-card>
                                <div slot="">
                                    <div class="title-text">{{c}}</div>
                                    <marquee class="marquee-value-text"
                                             v-if="yxValues[rindex][cindex] != null && yxValues[rindex][cindex].length > 6">
                                        {{yxValues[rindex][cindex]}}
                                    </marquee>
                                    <div
                                      :class="{'null-value-text':yxValues[rindex][cindex]=='等待上报' ,'value-text':yxValues[rindex][cindex]!='等待上报'}"
                                      v-if="yxValues[rindex][cindex] != null && yxValues[rindex][cindex].length <= 6">
                                        {{yxValues[rindex][cindex]}}
                                    </div>
                                    <div class="unit-text">{{yxUnits[rindex][cindex]}}</div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-tab-pane>

                <el-tab-pane label="行为统计" name="2">
                    <el-row style="font-size: 10px;font-weight: bold;color: #808c939d;"> {{xwUpdateTime}}</el-row>
                    <el-row :gutter="0" v-for="(r,rindex) in xwTitles">
                        <el-col :span="6" v-for="(c, cindex) in r" :key="c.name" :offset="0" v-show="c.show">
                            <el-card>
                                <div slot="">
                                    <div class="title-text">{{c.name}}</div>
                                    <div
                                      :class="{'null-value-text':xwValues[rindex][cindex]=='等待上报' ,'value-text':xwValues[rindex][cindex]!='等待上报'}">
                                        {{xwValues[rindex][cindex]}}
                                    </div>
                                    <div class="unit-text">{{xwUnits[rindex][cindex]}}</div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-tab-pane>

                <el-tab-pane label="家庭康复" name="3">
                    <el-row style="font-size: 10px;font-weight: bold;color: #808c939d;"> {{xwUpdateTime}}</el-row>
                    <el-row :gutter="0" v-for="(r,rindex) in kfTitles">
                        <el-col :span="6" v-for="(c, cindex) in r" :key="c.name" :offset="0" v-show="c.show">
                            <el-card>
                                <div>
                                    <div class="title-text">{{c.name}}</div>
                                    <el-button
                                      v-if="cindex==0 && (dev_edition==XZ_SPORT || dev_edition==XZ_SPORT_LITE || dev_edition==XZ_WHEELCHAIR || dev_edition == XZ_HOME)&& kfValues[rindex][cindex] >0"
                                      type="text"
                                      style="display: inline-block;float: right"
                                      @click="handlePeriodAnalyze(curDid)">
                                        前3月时段分布
                                    </el-button>
                                    <div
                                      :class="{'null-value-text':kfValues[rindex][cindex]=='等待上报' ,'value-text':kfValues[rindex][cindex]!='等待上报'}">
                                        {{kfValues[rindex][cindex]}}
                                    </div>
                                    <div class="unit-text">{{kfUnits[rindex][cindex]}}</div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-tab-pane>

                <el-tab-pane label="错误日志" name="4">
                    <el-table :data="deviceErrorLogList">
                        <el-table-column label="#" width="50" align="center">
                            <template slot-scope="scope">
                                {{scope.$index+1}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="content" label="日志内容"/>
                        <el-table-column prop="received_time" label="接收时间" width="180" align="center"/>
                    </el-table>
                    <el-pagination
                      background
                      layout="prev, pager, next"
                      :page-size="deviceErrorLogPageSize"
                      :current-page="deviceErrorLogCurPage"
                      :total="deviceErrorLogTotal"
                      @current-change="handleErrorLogPageChanged">
                    </el-pagination>
                </el-tab-pane>

            </el-tabs>
        </el-dialog>

        <el-dialog title="前3月时段分布" :visible.sync="periodDetailsVisiable" width="90%" top="0%"
                   :before-close="closePeriodDetailDialog">
            <!--                        <div style="margin: 0 auto;text-align: center;">筛选:-->
            <!--                            <el-date-picker v-model="choosedate" size="mini" type="date" placeholder="选择日期"-->
            <!--                                            value-format="timestamp"></el-date-picker>-->
            <!--                            之后的90天-->
            <!--                            <el-button type="primary" size="mini" icon="el-icon-search" circle @click="nineSearch"></el-button>-->
            <!--                        </div>-->


            <!--            <el-form :inline="true">-->
            <!--                <el-form-item>-->
            <!--                    <el-input v-model="deleteHour" placeholder="清除的小时数" size="small"></el-input>-->
            <!--                </el-form-item>-->
            <!--                <el-form-item>-->
            <!--                    <el-input v-model="deleteMonthAndBefore" placeholder="清除当月及以前月" size="small"></el-input>-->
            <!--                </el-form-item>-->
            <!--            </el-form>-->
            <!--            <el-button @click="delete6hour" type="text">S1.清除n小时以上</el-button>-->
            <!--            <el-button @click="deleteMonthAndBeforeMonth" type="text">S2.清除某月及以前月</el-button>-->
            <!--            <el-button @click="randingDelete" type="text">全盘随机</el-button>-->
            <!--            <el-button @click="getDeleteData">获取待删数据</el-button>-->
            <!--            <el-button @click="uploadMark" type="success">上传标记</el-button>-->
            <!--            <span>在线总天数：{{usedays}}天，发货总天数：{{outdays}}天，使用概率{{(usedays/outdays*100).toFixed(0)}}%，日均在线时长：{{dailyavghours}}小时，{{totalSecs}}s</span>-->


            <div id="DetailBox" class="box-charts"></div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        GetDeviceStatusErrorLogList,
        GetDeviceStatusOverviewList,
        GetDeviceStatusDetailsList,
        GetSportDevDetail,
        MarkDeviceRecords
    } from '../api/api';
    import moment from 'moment';
    import echarts from 'echarts';
    import {Loading} from 'element-ui';

    export default {
        data() {
            return {
                dayslastday: '',
                firstday: '',
                outdays: '',
                usedays: 0,
                totalSecs: 0,
                dailyavghours: 0,
                deleteHour: 6,
                deleteMonthAndBefore: 7,
                isdeletingBeforeMonth: false,
                isdeleting6hour: false,
                israndingDelete: false,
                isfirstloading: true,
                tmpClickToDelete: {},
                //
                token: '',
                Limits: '',
                // 列表分页
                Pagesize: 20,
                Curpage: 1,
                total: 1,
                List: [],
                SearchDid: '',
                SearchEdition: '',
                SearchOnlineStatus: '',
                // 详情内容
                detailsVisiable: false,
                periodDetailsVisiable: false,
                // 时段分布图表
                It: "",
                which: {},
                charts: "",
                choosedate: '',
                finaldata: [],
                newObj: [],
                startTime: 0,
                // 用户信息
                last_online_time: '',
                dev_software_version_r: '',
                dev_software_version_f: '',
                dev_edition: '',
                curDid: '',
                shipping_prov: '',
                shipping_city: '',
                shipping_dist: '',
                shipping_addr: '',
                // tab标签
                tabActiveName: '1',
                // 运行状态
                yxUpdateTime: '<暂无数据>',
                yxTitles: [
                    [
                        '剩余电量',
                        '电池充电状态',
                        '锁定状态',
                        '蓝牙连接状态'
                    ], [
                        'GPS定位'
                    ]
                ],
                yxValues: [
                    [
                        -1,
                        -1,
                        -1,
                        -1
                    ], [
                        -1
                    ]
                ],
                yxUnits: [
                    [
                        '%',
                        '-',
                        '-',
                        '-'
                    ], [
                        '-'
                    ]
                ],
                // 行为统计
                xwUpdateTime: '<暂无数据>',
                xwTitles: [
                    [
                        {name: '限速次数', show: true},
                        {name: '颠簸次数', show: true},
                        {name: '倾斜次数', show: true},
                        {name: '急转次数', show: true}
                    ], [
                        {name: '协助转移时长', show: true},
                        {name: '高速行驶时间', show: true},
                        {name: '低速行驶时间', show: true},
                        {name: 'SOS报警次数', show: true}
                    ], [
                        {name: '电动座椅使用时长', show: true},
                        {name: '缠绕绳使用时长', show: true},
                        {name: '电动摆臂使用时长', show: true},
                        {name: '电动脚踏使用时长', show: true}
                    ], [
                        {name: '锁定按键使用次数', show: true},
                        {name: '速度按键使用次数', show: true},
                        {name: 'SOS按键使用次数', show: true},
                        {name: '开机按键使用次数', show: true}
                    ], [
                        {name: '左前按键使用次数', show: true},
                        {name: '左后按键使用次数', show: true},
                        {name: '右前按键使用次数', show: true},
                        {name: '右后按键使用次数', show: true}
                    ]
                ],
                // xwTitles: [
                //     [
                //         '限速次数',
                //         '颠簸次数',
                //         '倾斜次数',
                //         '急转次数'
                //     ], [
                //         '协助转移时长',
                //         '高速行驶时间',
                //         '低速行驶时间',
                //         'SOS报警次数'
                //     ], [
                //         '电动座椅使用时长',
                //         '缠绕绳使用时长',
                //         '电动摆臂使用时长',
                //         '电动脚踏使用时长'
                //     ], [
                //         '锁定按键使用次数',
                //         '速度按键使用次数',
                //         'SOS按键使用次数',
                //         '开机按键使用次数（长按）'
                //     ], [
                //         '左前按键使用次数',
                //         '左后按键使用次数',
                //         '右前按键使用次数',
                //         '右后按键使用次数'
                //     ]
                // ],
                xwValues: [
                    [
                        -1,
                        -1,
                        -1,
                        -1
                    ], [
                        -1,
                        -1,
                        -1,
                        -1
                    ], [
                        -1,
                        -1,
                        -1,
                        -1
                    ], [
                        -1,
                        -1,
                        -1,
                        -1
                    ], [
                        -1,
                        -1,
                        -1,
                        -1
                    ]
                ],
                xwUnits: [
                    [
                        '次',
                        '次',
                        '次',
                        '次'
                    ], [
                        '秒',
                        '秒',
                        '秒',
                        '次',
                    ], [
                        '秒',
                        '秒',
                        '秒',
                        '秒'
                    ], [
                        '次',
                        '次',
                        '次',
                        '次'
                    ], [
                        '次',
                        '次',
                        '次',
                        '次'
                    ]
                ],
                // 家庭康复
                kfTitles: [
                    [
                        {name: '站立训练时长', show: true},
                        {name: '蹲起个数', show: true},
                        {name: '平衡训练时长', show: false},
                        {name: '跟腱训练时长', show: false},
                    ]
                ],
                kfValues: [
                    [
                        -1,
                        -1,
                        -1,
                        -1
                    ]
                ],
                kfUnits: [
                    [
                        '秒',
                        '个',
                        '秒',
                        '秒'
                    ]
                ],
                // 错误日志
                deviceErrorLogList: [],
                deviceErrorLogPageSize: 10,
                deviceErrorLogCurPage: 1,
                deviceErrorLogTotal: 1,
                isSport: false,
                isSportLite: false,
                isHome: false,
                isWheelChair: false,
                isChild: false,
                XZ_SPORT: '重度失能版',
                XZ_SPORT_LITE: '轻度失能版',
                XZ_HOME: '标准版',
                XZ_WHEELCHAIR: '智能轮椅',
                XZ_CHILD: '儿童版'
            }
        },
        methods: {
            getDeviceVersionName(product_code, edition_code) {
                if (product_code == 'B' && edition_code == '1') {
                    return this.XZ_WHEELCHAIR;
                } else if (product_code == 'A' && edition_code == '1') {
                    return this.XZ_HOME;
                } else if (product_code == 'A' && edition_code == '8') {
                    return this.XZ_SPORT_LITE;
                } else if (product_code == 'A' && edition_code == '9') {
                    return this.XZ_CHILD;
                } else {
                    return this.XZ_SPORT;
                }
            },
            judgeDeviceVersion(product_code, edition_code) {
                this.isWheelChair = false
                this.isHome = false
                this.isSportLite = false
                this.isSport = false
                this.isChild = false
                switch (this.getDeviceVersionName(product_code, edition_code)) {
                    case this.XZ_WHEELCHAIR:
                        this.isWheelChair = true
                        break
                    case this.XZ_HOME:
                        this.isHome = true
                        break
                    case this.XZ_SPORT_LITE:
                        this.isSportLite = true
                        break
                    case this.XZ_SPORT:
                        this.isSport = true
                        break
                    case this.XZ_CHILD:
                        this.isChild = true
                        break
                }
            },
            gotoDetails(row, index, col) {
                var that = this;
                this.resetStatus();
                this.detailsVisiable = true;
                this.curDid = row.device_name;
                this.dev_edition = this.getDeviceVersionName(row.product_code, row.edition_code)
                this.last_online_time = row.last_time;

                this.judgeDeviceVersion(row.product_code, row.edition_code)

                // 兼容UI
                this.xwTitles = [
                    [
                        {name: '限速次数', show: true},
                        {name: '颠簸次数', show: true},
                        {name: '倾斜次数', show: true},
                        {name: '急转次数', show: true}
                    ], [
                        {name: this.isWheelChair ? "开机时长" : '协助转移时长', show: true},
                        {name: '高速行驶时间', show: true},
                        {name: '低速行驶时间', show: true},
                        {name: 'SOS报警次数', show: true}
                    ], [
                        {name: '电动座椅使用时长', show: !this.isWheelChair},
                        {name: '缠绕绳使用时长', show: !this.isWheelChair},
                        {name: '电动摆臂使用时长', show: !this.isWheelChair},
                        {name: '电动脚踏使用时长', show: !this.isWheelChair}
                    ], [
                        {name: this.isWheelChair ? '锁定按键使用次数' : '锁定按键使用次数', show: true},
                        {name: this.isWheelChair ? '喇叭按键使用次数' : '速度按键使用次数', show: true},
                        {name: this.isWheelChair ? '速度+按键使用次数' : 'SOS按键使用次数', show: true},
                        {name: this.isWheelChair ? '速度-按键使用次数' : '开机按键使用次数', show: true}
                    ], [
                        {name: this.isWheelChair ? '模式按键使用次数' : '左前按键使用次数', show: true},
                        {name: this.isWheelChair ? 'SOS按键使用次数' : '左后按键使用次数', show: true},
                        {name: this.isWheelChair ? '开机按键使用次数' : '右前按键使用次数', show: true},
                        {name: this.isWheelChair ? '轮椅折叠次数' : '右后按键使用次数', show: true}
                    ]
                ];
                this.kfTitles = [
                    [
                        {name: this.isWheelChair ? '在线时长' : '站立训练时长', show: true},
                        {name: '蹲起个数', show: !this.isWheelChair},
                        {name: '平衡训练时长', show: false},
                        {name: '跟腱训练时长', show: false},
                    ]
                ];

                GetDeviceStatusDetailsList(row.device_name, {token: this.token}).then(res => {
                    var data = res.data;
                    console.log("lbfres", data);
                    that.dev_software_version_r = data.r_version;
                    that.dev_software_version_f = data.f_version;
                    that.shipping_prov = data.deliveryOrder.shipping_prov;
                    that.shipping_city = data.deliveryOrder.shipping_city;
                    that.shipping_dist = data.deliveryOrder.shipping_dist;
                    that.shipping_addr = data.deliveryOrder.shipping_addr;
                    if (data.r_received_time != null) {
                        that.yxUpdateTime = '更新于' + data.r_received_time;//实时数据
                    }
                    if (data.f_received_time != null) {
                        that.xwUpdateTime = '更新于' + data.f_received_time;//Flash数据
                    }
                    that.yxValues = [
                        [
                            data.battery == null ? null : data.battery + "",
                            data.is_charging == null ? null : (data.is_charging == '0' ? '否' : '是'),
                            data.locked == null ? null : (data.locked == '0' ? '否' : '是'),
                            data.bluetooth == null ? null : (data.bluetooth == '0' ? '否' : '是')//蓝牙连接
                        ], [
                            data.geo_location == null ? '室内' : data.geo_location
                        ]
                    ];
                    that.xwValues = [
                        [
                            data.speed_limit_times,
                            data.bump_times,
                            data.tilt_times,
                            data.sharp_turn_times,
                        ], [
                            data.motors_usage.HubMotor,
                            data.speed_stage_high,
                            data.speed_stage_low,
                            data.buttons_usage.Sos
                        ], [
                            data.motors_usage.SeatMotor,
                            data.motors_usage.WindingMotor,
                            data.motors_usage.SwingArmMotor,
                            data.motors_usage.FootMotor,
                        ], [
                            that.isWheelChair ? data.buttons_usage.Locked : data.buttons_usage.Locked,
                            that.isWheelChair ? data.buttons_usage.Buzzer : data.buttons_usage.Speed,
                            that.isWheelChair ? data.buttons_usage.SpeedUp : data.buttons_usage.Sos,
                            that.isWheelChair ? data.buttons_usage.SpeedDown : data.buttons_usage.Power
                        ], [
                            that.isWheelChair ? data.buttons_usage.ModeKey : (that.isSport ? data.buttons_usage.WindingBeltIn : ((that.isSportLite || that.isChild) ? data.buttons_usage.LiftUp : "未知")),
                            that.isWheelChair ? data.buttons_usage.Sos : (that.isSport ? data.buttons_usage.WindingBeltOut : ((that.isSportLite || that.isChild) ? data.buttons_usage.LiftDown : "未知")),
                            that.isWheelChair ? data.buttons_usage.Power : (that.isSport ? data.buttons_usage.SeatDown : ((that.isSportLite || that.isChild) ? data.buttons_usage.SwingArmDown : "未知")),
                            that.isWheelChair ? data.training_mode_times : (that.isSport ? data.buttons_usage.SeatUp : ((that.isSportLite || that.isChild) ? data.buttons_usage.SwingArmUp : "未知"))
                        ]
                    ];
                    that.kfValues = [
                        [
                            data.running_time,
                            data.squat_times,
                            0,
                            0
                        ]
                    ];
                }).catch(err => {
                    console.log('lbferr', err);
                });
            },
            resetStatus() {
                this.tabActiveName = '1';
                this.last_online_time = '';
                this.dev_software_version_r = '';
                this.dev_software_version_f = '';
                this.dev_edition = '';
                this.curDid = '';
                this.yxUpdateTime = '<暂无数据>';
                this.xwUpdateTime = '<暂无数据>';
                this.yxValues = [
                    [
                        '等待上报',
                        '等待上报',
                        '等待上报',
                        '等待上报'
                    ], [
                        '等待上报'
                    ]
                ];
                this.xwValues = [
                    [
                        '等待上报',
                        '等待上报',
                        '等待上报',
                        '等待上报'
                    ], [
                        '等待上报',
                        '等待上报',
                        '等待上报',
                        '等待上报'
                    ], [
                        '等待上报',
                        '等待上报',
                        '等待上报',
                        '等待上报'
                    ], [
                        '等待上报',
                        '等待上报',
                        '等待上报',
                        '等待上报'
                    ], [
                        '等待上报',
                        '等待上报',
                        '等待上报',
                        '等待上报'
                    ]
                ];
                this.kfValues = [
                    [
                        '等待上报',
                        '等待上报',
                        '等待上报',
                        '等待上报'
                    ]
                ];
                this.deviceErrorLogList = [];
            },
            clickTab(tab, event) {
                console.log("lbftab", tab.index, event);
                var that = this;
                if (tab.index == 3) {// 错误日志
                    GetDeviceStatusErrorLogList(this.curDid, {
                        token: that.token,
                        'per-page': that.deviceErrorLogPageSize
                    }).then(res => {
                        that.deviceErrorLogList = res.data.items;
                        that.deviceErrorLogTotal = res.data.meta.totalCount;
                        that.deviceErrorLogCurPage = res.data.meta.currentPage;
                        that.deviceErrorLogPageSize = res.data.meta.perPage;
                    }).catch(err => {
                    });
                }
            },
            handleErrorLogPageChanged(val) {
                var that = this;
                this.deviceErrorLogCurPage = val;
                GetDeviceStatusErrorLogList(this.curDid, {
                    token: that.token,
                    page: that.deviceErrorLogCurPage,
                    'per-page': that.deviceErrorLogPageSize
                }).then(res => {
                    that.deviceErrorLogList = res.data.items;
                    that.deviceErrorLogTotal = res.data.meta.totalCount;
                    that.deviceErrorLogCurPage = res.data.meta.currentPage;
                    that.deviceErrorLogPageSize = res.data.meta.perPage;
                }).catch(err => {
                });
            },
            handlePageChanged(val) {
                this.Curpage = val;
                var param = {
                    page: this.Curpage,
                    token: this.token,
                    sort: '-online_status'
                };
                if (this.SearchEdition) {
                    // param['edition'] = this.SearchEdition;
                }
                if (this.SearchOnlineStatus) {
                    param['filter[online_status]'] = this.SearchOnlineStatus;
                }
                this.GetList(GetDeviceStatusOverviewList, param);
            },
            handlePeriodAnalyze(did) {
                var that = this;
                this.periodDetailsVisiable = true;
                // this.It = column.columnKey;
                // this.which = Object.assign({}, row);
                this.which.did = did;
//				一个月前的第一天0点
                var lastM_start = parseInt(new Date(new Date(new Date().toLocaleDateString()).setMonth(new Date().getMonth() - 3)).getTime() / 1000);
//				昨晚23：59：59
                var yes_endDate = parseInt(new Date(new Date(new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).getTime() / 1000);

                // 只查看8～10月
                // lastM_start = parseInt(new Date(2019, 7, 1, 0, 0, 0, 0).getTime() / 1000);
                // yes_endDate = parseInt(new Date(2019, 9, 31, 23, 59, 59, 0).getTime() / 1000);

                this.getdata(that.which.did, lastM_start, yes_endDate, Math.ceil((yes_endDate - lastM_start) / 60 / 60 / 24));
            },


            getdata(did, starttime, endtime, days) {
                var that = this;

                var newdata = [];
                var allLast = [];
                var condit = [{"AND": {"did": did}}, {"BETWEEN": {"date": [starttime, endtime]}}];
                var condit2 = JSON.stringify(condit);

                var param = {
                    page: 1,
                    token: that.token,
                    perPage: 50,
                    q: condit2
                }

                GetSportDevDetail(param).then(res => {
                    newdata = res.data.items

                    var allcount = res.data.meta.pageCount
                    if (allcount > 1) {
                        var para = {
                            page: 2,
                            token: that.token,
                            perPage: 50,
                            q: condit2
                        }
                        GetSportDevDetail(para).then(res => {
                            Array.prototype.push.apply(newdata, res.data.items);
//								获取y轴yline
                            var yline = []
                            for (var i = 0; i < days; i++) {
                                var ttt = starttime + 86400 * i
                                yline.push(moment(ttt * 1000).format("MM/DD"))

                                allLast[i] = {}
                                allLast[i].dalydate = yline[i]
                            }

                            for (var m = 0; m < allLast.length; m++) {
                                allLast[m].dur = []
                                for (var n = 0; n < newdata.length; n++) {
                                    if (allLast[m].dalydate == moment(newdata[n].date * 1000).format("MM/DD")) {
                                        for (var j = 0; j < newdata[n].records.length; j++) {
                                            var arr = []
                                            arr.push(newdata[n].records[j].turn_on_at)
                                            arr.push(newdata[n].records[j].turn_off_at)
                                            arr.push(newdata[n].records[j].mileage)
                                            arr.push(newdata[n].records[j].squat)
                                            allLast[m].dur[j] = arr
                                        }
                                    }
                                }
                            }

                            that.categories = []
                            that.newObj = allLast

                            console.log('lbf', that.newObj);

                            for (var i in that.newObj) {
                                that.categories.push(that.newObj[i].dalydate)
                            }

                            that.datafor()

//								获取完数据画图
                            that.$nextTick(function () {
                                that.DrawPie()
                            })
                        }).catch(err => {
                            console.log(err)
                        })
                    } else {

//					获取y轴yline
                        var yline = []
                        for (var i = 0; i < days; i++) {
                            var ttt = starttime + 86400 * i
                            yline.push(moment(ttt * 1000).format("MM/DD"))

                            allLast[i] = {}
                            allLast[i].dalydate = yline[i]
                        }


                        for (var m = 0; m < allLast.length; m++) {
                            allLast[m].dur = []
                            for (var n = 0; n < newdata.length; n++) {
                                if (allLast[m].dalydate == moment(newdata[n].date * 1000).format("MM/DD")) {
                                    for (var j = 0; j < newdata[n].records.length; j++) {
                                        var arr = []
                                        arr.push(newdata[n].records[j].turn_on_at)
                                        arr.push(newdata[n].records[j].turn_off_at)
                                        arr.push(newdata[n].records[j].mileage)
                                        arr.push(newdata[n].records[j].squat)
                                        allLast[m].dur[j] = arr
                                    }
                                }
                            }
                        }

                        that.categories = []
                        that.newObj = allLast

                        console.log('lbf', that.newObj);

                        for (var i in that.newObj) {
                            that.categories.push(that.newObj[i].dalydate)
                        }
                        that.datafor()

//				获取完数据画图
                        that.$nextTick(function () {
                            that.DrawPie()
                        })
                    }
                }).catch(err => {
                    console.log('err', err)
                })
            },
            datafor() {
                var that = this;
                var item_style = {
                    normal: {
                        // color: '#7b9ce1',
                        opacity: 1
                    },
                    emphasis: {
                        // color: '#0f0',
                        opacity: 1
                    }
                };
                echarts.util.each(that.categories, function (category, index) {
                    var baseTime = that.newObj[index].dur;
                    var toptime = that.newObj[index].dalydate
                    if (baseTime.length == 0) {
                        that.finaldata.push({
                            name: '使用时长',
                            value: [
                                index,
                                '0',
                                '0',
                                '0',
                                '0',
                                '0',
                                toptime
                            ],
                            itemStyle: item_style
                        });
                    } else {
                        for (var i = 0; i < baseTime.length; i++) {
//						console.log(123)
                            if (baseTime[i].length > 1) {
                                // console.log('baseTime',baseTime[i][0],that.dateFormate(baseTime[i][0]));
                                that.finaldata.push({
                                    name: '使用时长',
                                    value: [
                                        index,
                                        that.dateFormate(baseTime[i][0]),
                                        that.dateFormate(baseTime[i][1]),
                                        that.dateFormate(baseTime[i][1]) - that.dateFormate(baseTime[i][0]),
                                        baseTime[i][2],
                                        baseTime[i][3],
                                        toptime
                                    ],
                                    itemStyle: item_style
                                });
                            } else {
                                // console.log('baseTime',baseTime[i][0],that.dateFormate(baseTime[i][0]));
                                that.finaldata.push({
                                    name: '使用时长',
                                    value: [
                                        index,
                                        '0',
                                        '0',
                                        '0',
                                        '0',
                                        '0',
                                        toptime
                                    ],
                                    itemStyle: item_style
                                });
                            }
                        }
                    }
                });
//				console.log('that.finaldata',that.finaldata)
                that.Seric = [
                    {
                        type: 'custom',
                        renderItem: that.renderItem,
                        itemStyle: {
                            normal: {
                                // color: '#7b9ce1',
                                opacity: 1
                            },
                            emphasis: {
                                // color: '#f00',
                                opacity: 1
                            }
                        },
                        encode: {
                            x: [1, 2],
                            y: 0
                        },
                        data: that.finaldata
                    }
                ];
            },
            renderItem(params, api) {
                var categoryIndex = api.value(0);
                var start = api.coord([api.value(1), categoryIndex]);
                var end = api.coord([api.value(2), categoryIndex]);
                var height = api.size([0, 1])[1] * 0.6;
                var rectShape = echarts.graphic.clipRectByRect({
                    x: start[0],
                    y: start[1] - height / 2,
                    width: end[0] - start[0],
                    height: height
                }, {
                    x: params.coordSys.x,
                    y: params.coordSys.y,
                    width: params.coordSys.width,
                    height: params.coordSys.height
                });

                var curTurnonTimestamp = this.dateReFormate(api.value(1), api.value(6));
                var curTurnoffTimestamp = this.dateReFormate(api.value(2), api.value(6));

                // 后端bug，turnon时间是29号，turnoff时间是30号
                // if (api.value(0) == 89) {
                //     console.log('lbftest-off', curTurnoffTimestamp, api.value(2), api.value(6));
                //     console.log('lbftest-on', curTurnonTimestamp, api.value(1), api.value(6));
                // }

                if (this.isdeleting6hour) {
                    var deltaSec = curTurnoffTimestamp - curTurnonTimestamp;
                    var hour = deltaSec / 3600;
                    this.tmpClickToDelete[curTurnonTimestamp] = (hour >= this.deleteHour) ? 1 : 0;
                }
                if (this.israndingDelete) {
                    this.tmpClickToDelete[curTurnonTimestamp] = (Math.round(Math.random()) == 0) ? 0 : 1;
                }
                if (this.isfirstloading) {
                    this.tmpClickToDelete[curTurnonTimestamp] = 0;
                }

                if (this.isdeletingBeforeMonth) {// 删除某月之前
                    var month = parseInt(api.value(6).split('/')[0]);
                    // console.log("lbfmonth",month,this.deleteMonthAndBefore);
                    if (month <= this.deleteMonthAndBefore) {
                        this.tmpClickToDelete[curTurnonTimestamp] = 1;
                    }
                }

                if (this.tmpClickToDelete[curTurnonTimestamp] == 0) {// 统计留下的
                    if (this.dayslastday != api.value(6)) {
                        if (this.dayslastday == '') {// 记录第一天的时间，计算发货天数
                            this.firstday = api.value(6);
                            console.log('lbf123', this.firstday);
                            this.outdays = 1 + (new Date(2019, 10, 31).getTime() / 1000 - new Date(2019, this.firstday.split('/')[0], this.firstday.split('/')[1]).getTime() / 1000) / 60 / 60 / 24;
                        }
                        this.usedays++;//留下的天数
                        this.dayslastday = api.value(6);
                    }
                    this.totalSecs += (curTurnoffTimestamp - curTurnonTimestamp);//累加总在线时长
                    console.log('lbtt', api.value(0), curTurnoffTimestamp, curTurnonTimestamp, curTurnoffTimestamp - curTurnonTimestamp);
                    this.dailyavghours = (this.totalSecs / 3600 / this.usedays).toFixed(1);// 日均小时数
                }


                var style;
                if (this.tmpClickToDelete[curTurnonTimestamp] == 0) {
                    style = api.style();
                } else {
                    style = api.style({opacity: 0.05});// 1是被删除
                }
                // console.log('lbfclick3', api.value(0),
                //     this.dateReFormate(api.value(1), api.value(6)),
                //     this.dateReFormate(api.value(2), api.value(6)));
                return rectShape && {
                    type: 'rect',
                    shape: rectShape,
                    style: style
                };
            },
            randingDelete() {
                this.usedays = 0;
                this.totalSecs = 0;
                this.dailyavghours = 0;
                this.dayslastday = '';
                this.isdeletingBeforeMonth = false;
                this.isdeleting6hour = false;
                this.israndingDelete = true;
                this.isfirstloading = false;
                this.opt();
            },
            delete6hour() {
                this.usedays = 0;
                this.totalSecs = 0;
                this.dailyavghours = 0;
                this.dayslastday = '';
                this.isdeletingBeforeMonth = false;
                this.isdeleting6hour = true;
                this.israndingDelete = false;
                this.isfirstloading = false;
                this.opt();
            },
            deleteMonthAndBeforeMonth() {
                this.usedays = 0;
                this.totalSecs = 0;
                this.dailyavghours = 0;
                this.dayslastday = '';
                this.isdeletingBeforeMonth = true;
                this.isdeleting6hour = false;
                this.israndingDelete = false;
                this.isfirstloading = false;
                this.opt();
            },
            getDeleteData() {
                var l = 0, total = 0;
                for (var k in this.tmpClickToDelete) {
                    if (this.tmpClickToDelete[k] == 1) {
                        l++;
                    }
                    total++;
                }
                console.log('lbfclick4', l, total, this.tmpClickToDelete);
            },
            uploadMark() {
                var param = {
                    did: this.curDid,
                    times: this.tmpClickToDelete
                };
                console.log('lbfclick5', param);

                var loadingInstance = Loading.service({fullscreen: true});
                // window.clipboardData.setData('lbf',param);

                MarkDeviceRecords(this.token, param).then(res => {
                    console.log("lbfclick6:", res);
                    this.$notify({
                        title: '成功',
                        message: '上传成功',
                        type: 'success'
                    });
                    this.$nextTick(() => {
                        loadingInstance.close();
                    });
                }).catch(err => {
                    console.log("lbfclick6-err:", err);
                    this.$notify.error({
                        title: '失败',
                        message: '上传失败'
                    });
                    this.$nextTick(() => {
                        loadingInstance.close();
                    });
                });
            },
            nineSearch() {
                var that = this
                this.finaldata = []
                this.newObj = []
                this.Seric = []
                this.charts.dispose();
                if (this.choosedate) {
                    var startDate = parseInt(this.choosedate / 1000);
                    var endDate = parseInt(new Date(startDate * 1000).setMonth(new Date(startDate * 1000).getMonth() + 3) / 1000);

                    this.getdata(that.which.did, startDate, endDate, Math.ceil((endDate - startDate) / 60 / 60 / 24));
                } else {
//				一个月前的第一天0点
                    var lastM_start = parseInt(new Date(new Date(new Date().toLocaleDateString()).setMonth(new Date().getMonth() - 1)).getTime() / 1000);
//				昨晚23：59：59
                    var yes_endDate = parseInt(new Date(new Date(new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).getTime() / 1000);


                    this.getdata(that.which.did, lastM_start, yes_endDate, Math.ceil((yes_endDate - lastM_start) / 60 / 60 / 24));
                }
            },
            closeDeviceStatusDetailDialog() {
                this.detailsVisiable = false;
            },
            closePeriodDetailDialog() {
                this.finaldata = []
                this.newObj = []
                this.Seric = []
                this.choosedate = ''
                this.charts.dispose()
                this.periodDetailsVisiable = false;

                this.usedays = 0;
                this.totalSecs = 0;
                this.dailyavghours = 0;
                this.tmpClickToDelete = {};
                this.dayslastday = '';
                this.isdeletingBeforeMonth = false;
                this.isdeleting6hour = false;
                this.israndingDelete = false;
                this.isfirstloading = true;
            },
            DrawPie() {
                var that = this;
                that.charts = echarts.init(document.getElementById('DetailBox'));
                that.opt();

                // that.charts.on('click', function (params) {
                //     that.usedays = 0;
                //     that.totalSecs = 0;
                //     that.dailyavghours = 0;
                //     that.dayslastday = '';
                //     that.isdeletingBeforeMonth = false;
                //     that.isdeleting6hour = false;
                //     that.israndingDelete = false;
                //     that.isfirstloading = false;
                //     var turnon_moment_timestamp = that.dateReFormate(params.value[1], params.value[6]);
                //     var turnoff_moment_timestamp = that.dateReFormate(params.value[2], params.value[6]);
                //     console.log('lbfclick1', turnon_moment_timestamp, turnoff_moment_timestamp);
                //     that.tmpClickToDelete[turnon_moment_timestamp]
                //         = (that.tmpClickToDelete[turnon_moment_timestamp] == 1) ? 0 : 1;
                //     that.opt();
                // });
            },
            opt() {
                var that = this;
                // for (var i = 0; i < that.nameList.length; i++) {
                //     if (that.nameList[i].en == that.It) {
                //         that.barname = that.nameList[i].cn
                //     }
                // }
                that.charts.setOption({
                    tooltip: {
                        formatter: function (params) {
                            var start = params.value[1]
                            var end = params.value[2]
                            var sformate = (parseInt(start / 3600) + '') + ':' + (parseInt((start % 3600) / 60) + '')
                            var eformate = (parseInt(end / 3600) + '') + ':' + (parseInt((end % 3600) / 60) + '')
                            var omas = params.data.othermas
//							for(var key in omas) {
//      						console.log(key)
//      						return key + ': ' + omas[key] + ' ms'
//							}
//                             return params.value[6] + '   ' + sformate + '-' + eformate + '</br>' + '使用' + ': ' + that.useDate(params.value[3]) + '</br>' + '行驶：' + params.value[4] + '米' + '</br>' + '蹲起：' + params.value[5] + '次';
                            return params.value[6] + '   ' + sformate + '-' + eformate + '</br>' + '使用' + ': ' + that.useDate(params.value[3]);
                        },
                        show: true
                    },
//					title: {
//						text: that.barname,
//						left: 'center'
//					},
//					grid: {
//						height: 800
//					},
                    xAxis: {
                        type: 'time',
                        boundaryGap: false,
                        min: that.startTime,
                        max: 86400,
                        interval: 3600,
                        axisLabel: {
                            formatter: function (val) {
                                return val / 3600 + ':00'
//								return val
                            }
                        }
                    },
                    yAxis: {
                        data: that.categories
                    },
                    series: that.Seric,
                    color: ['#00f']
                });
            },
            dateFormate(date) {
                var a = date * 1000
                var time = new Date(a)
                var h = time.getHours();
                var mm = time.getMinutes();
                var s = time.getSeconds();
                var last = h * 3600 + mm * 60 + s
                return last
            },
            dateReFormate(dailysec, date) {
                var hour = parseInt(dailysec / 3600);
                var min = parseInt((dailysec - hour * 3600) / 60);
                var sec = dailysec - hour * 3600 - min * 60;
                var month = date.split('/')[0];
                var day = date.split('/')[1];
                var timestamp = parseInt(new Date(2019, month - 1, day, hour, min, sec).getTime() / 1000);
                return timestamp;
            },
            useDate(val) {
                var s = val % 60
                var m = parseInt(val / 60) % 60
                var h = parseInt(parseInt(val / 60) / 60)
                if (h == 0) {
                    return m + '分' + s + '秒'
                } else if (h == 0 && m == 0) {
                    return s + '秒'
                } else {
                    return h + '小时' + m + '分' + s + '秒'
                }
            },

            Refresh() {
                this.SearchDid = "    ";//加这句才会有loading动画
                this.SearchDid = "";
                this.SearchEdition = "";
                this.SearchOnlineStatus = "";
                // this.inputCode = ""
                // this.inputNum = ""
                // this.Productvalue = ""
                // this.Vervalue = ""
                this.Curpage = 1;
                this.GetList(GetDeviceStatusOverviewList, {
                    page: this.Curpage,
                    token: this.token,
                    sort: "-online_status"
                });
            },
            SelectionQuery() {
                if (this.SearchDid) {
                    this.SearchEdition = "";
                    this.SearchOnlineStatus = "";
                    this.GetList(GetDeviceStatusOverviewList, {
                        page: this.Curpage,
                        token: this.token,
                        sort: "-online_status",
                        'filter[device_name]': this.SearchDid
                    })
                }
            },
            filterEdition(value, row, column) {
                const property = column['property'];
                console.log('456', value, row, column, property, row[property].substring(0, 3));
                return row[property].substring(0, 3) === value;
            },
            filterOnlineStatus(value, row, column) {
                const property = column['property'];
                console.log('123', value, row, column, property);
                return row[property] === value;
            },
            handleSelectByOnlineStatus(command) {
                this.SearchDid = "    ";//加这句才会有loading动画
                this.SearchDid = "";
                this.SearchEdition = "";
                this.SearchOnlineStatus = command;
                this.GetList(GetDeviceStatusOverviewList, {
                    page: this.Curpage,
                    token: this.token,
                    'filter[online_status]': this.SearchOnlineStatus
                })
            },
            handleSelectByEdition(command) {
                this.SearchDid = "    ";//加这句才会有loading动画
                this.SearchDid = "";
                this.SearchOnlineStatus = "";
                this.SearchEdition = command;
                this.GetList(GetDeviceStatusOverviewList, {
                    page: this.Curpage,
                    token: this.token,
                    sort: "-online_status",
                    // 'filter[device_name]': this.SearchEdition
                })
            },
            myMarquee() {
                console.log(this.msg);
                var that = this;
                that.interval = setInterval(function () {
                    //获取第一个字符
                    var start = that.msg.substring(0, 1);
                    //得到后面的字符
                    var end = that.msg.substring(1);
                    //重新赋值
                    that.msg = end + start;
                }, 400);
            }
        },
        created() {
            this.Limits = JSON.parse(sessionStorage.getItem("limits"))
            this.token = sessionStorage.getItem("BBRtoken");
            this.GetList(GetDeviceStatusOverviewList, {
                page: this.Curpage,
                token: this.token,
                sort: "-online_status"
            });
        },
        mounted() {
            // this.myMarquee();
        }
    }
</script>

<style scoped>
    .el-pagination {
        float: right;
        margin-top: 10px;
    }

    .title-text {
        font-weight: bold;
        font-size: 15px;
        display: inline-block;
        color: #5F6E82;
        margin-left: 6%;
        margin-top: 2%;
    }

    .value-text {
        font-weight: bold;
        font-size: 45px;
        color: #000000;
        margin-left: 6%;
        margin-top: 10%;
    }

    .null-value-text {
        font-weight: bold;
        font-size: 45px;
        color: #eeeeee;
        margin-left: 6%;
        margin-top: 10%;
    }

    .marquee-value-text {
        font-weight: bold;
        font-size: 45px;
        color: #000000;
        margin-left: 6%;
        margin-top: 8%;
        margin-bottom: -7%;
        line-height: 42px;
    }

    .unit-text {
        color: #808c939d;
        font-size: 12px;
        margin-top: 10%;
        margin-left: 6%;
    }

    .box-charts {
        height: 100%;
    }

    .marquee-item {
        height: 30px;
        line-height: 30px;
    }
</style>


// WEBPACK FOOTER //
// DeviceStatusManagement.vue?01b6e6fe